<template>
  <div>
    <h4 v-if="header">
      {{ header }}
    </h4>
    <div v-if="datacollection" class="vacancy-stat">
      <VacancyPolarAreaChart
        :chart-data="datacollection"
        :height="150"
      ></VacancyPolarAreaChart>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import moment from "moment";
import VacancyPolarAreaChart from "./VacancyPolarAreaChart";

export default {
  components: {
    VacancyPolarAreaChart
  },
  emits: ["chartDataSet"],
  props: {
    numbers: { type: Array, default: () => new Array() },
    metric: { type: String, default: null },
    header: { type: String },
    sourceIds: { type: Array, default: undefined },
    overrideDataCollection: { default: null, type: Object }
  },
  data() {
    if (this.overrideDataCollection) {
      let newDataCollection = {
        data: [],
        backroundColor: [],
        borderColor: []
      };
      let labels = [];
      for (let data of this.overrideDataCollection.datasets) {
        newDataCollection.data.push(data.data.reduce((pv, cv) => pv + cv, 0));
        labels.push(data.label);
        newDataCollection.borderColor.push(data.borderColor);
        newDataCollection.backroundColor.push(data.borderColor);
      }
      return {
        skip: true,
        datacollection: {
          labels,
          datasets: [newDataCollection]
        }
      };
    }
    return {
      datacollection: null,
      skip: false
    };
  },
  apollo: {
    biStats: {
      query: gql`
        query BiStats($filter: BIStatsFilter!) {
          biStats(filter: $filter) {
            interval
            numDatapoints
            datapoints {
              time
              interval
              amount
              amountUnique
              type
              info {
                vacancy {
                  id
                  number
                  title
                }
              }
            }
          }
        }
      `,
      variables() {
        return {
          filter: {
            vacancyNumber: this.numbers,
            interval: 10080,
            grouping: "VACANCY",
            fromTime: moment().subtract(7, "days"),
            metrics: [this.metric],
            sourceID: this.sourceIds
          }
        };
      },
      skip() {
        return this.skip;
      }
    }
  },
  watch: {
    numbers() {},
    biStats(stats) {
      if (!stats.datapoints) {
        this.datacollection = null;
        return;
      }

      stats.datapoints.sort((a, b) =>
        a.time > b.time ? 1 : a.time < b.time ? -1 : 0
      );

      let labels = [];
      for (let data of stats.datapoints) {
        if (!data.info || !data.info.vacancy) {
          continue;
        }

        const title = `${data.info.vacancy.number} - ${data.info.vacancy.title}`;
        if (labels.findIndex(val => val === title) === -1) {
          labels.push(title);
        }
      }

      let ChartData = [];

      for (let label of labels) {
        let dataAmount = 0;
        for (let data of stats.datapoints) {
          let title = label;
          try {
            title = `${data.info.vacancy.number} - ${data.info.vacancy.title}`;
          } catch (e) {
            //eslint-ignore-line
          }
          if (
            label === title &&
            data.type === "VISITORS" &&
            this.metric == "VISITORS"
          ) {
            dataAmount = data.amountUnique;
          } else if (
            data.type === "APPLICATIONS_SENT" &&
            this.metric == "APPLICATIONS_SENT"
          ) {
            dataAmount = data.amount;
          }
        }

        ChartData.push(dataAmount);
      }

      this.$emit("chartDataSet", ChartData);

      this.datacollection = {
        labels,
        datasets: [
          {
            label: "Besucher (eindeutig)",
            data: ChartData,
            fill: true,
            backgroundColor: [
              "#13358e",
              "#48c6ef",
              "#55c400",
              "#d1232b",
              "#2e5573",
              "#48a600"
            ],
            pointHoverBackgroundColor: "#000000",
            lineTension: 0
          }
        ]
      };
    }
  }
};
</script>
